// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__GGW-J","label":"Category_label__1mssK","content":"Category_content__LcWn_","header":"Category_header__9s9AA","location":"Category_location__3DJOB"};